<template>
    <div class="m-portlet">
        <div class="m-portlet__head">
            <div class="m-portlet__head-caption">
                <div class="m-portlet__head-title">
                            <span v-if="icon" class="m-portlet__head-icon">
                                <i :class="icon"></i>
                            </span>
                    <h3 class="m-portlet__head-text">
                        {{title}}
                        <small v-if="subTitle">{{subTitle}}</small>
                    </h3>
                </div>
            </div>
            <div v-if="actions || actionsBlock" class="m-portlet__head-tools">
                <slot name="actionsBlock"></slot>
                <div class="btn-group">
                    <a href="#" role="button" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                        <i :class="actionsIcon"></i>
                    </a>
                    <div class="dropdown-menu dropdown-menu-right mr--20">
                        <a :href="a.url" class="dropdown-item" v-for="a in actions">{{a.name}}</a>
                    </div>
                </div>
            </div>
        </div>
        <div class="m-portlet__body">
            <slot name="portletBody"></slot>
        </div>
        <div class="m-portlet__foot" v-if="footer">
            <div class="row align-items-center">
                <slot name="portletFooter"></slot>
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        props: ['icon', 'title', 'subTitle', 'actionsBlock', 'actionsIcon', 'actions', 'footer'],
        data() {
            return {

            }
        }
    }
</script>

<style scoped lang="scss">
    .m-portlet__head-tools {
        > .btn-group:last-child {
            margin-left: 20px;
        }
        .btn {
            border-radius: 5px;
            padding: 4px 16px;
            font-size: 12px;
        }
        .btn-group > .btn-group:not(:last-child) > .btn,
        .btn-group > .btn:not(:last-child):not(.dropdown-toggle) {
            border-top-right-radius: 0;
            border-bottom-right-radius: 0;
        }
        .btn-group > .btn-group:not(:first-child) > .btn,
        .btn-group > .btn:not(:first-child) {
            border-top-left-radius: 0;
            border-bottom-left-radius: 0;
        }
    }
</style>
